import { Tooltip } from '@qr-front/ui/components/Tooltip'
import { cn } from '@qr-front/ui/utils'
import { ROUTES } from 'constants/routesConstants'
import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'
import { useRef } from 'react'

import { Link } from '@/i18n-routing'

import { previewColDef, scansColDef } from '../../columnsConfig'
import { isScansDataStaleAtom } from '../../tableState'
import { useCellValue } from '../../utils/cellValue'

export const MobileScans = () => {
	const t = useTranslations()
	const containerRef = useRef<HTMLDivElement>(null)

	const qrItem = useCellValue(previewColDef)
	const scans = useCellValue(scansColDef)
	const isDataStale = useAtomValue(isScansDataStaleAtom)

	return (
		<>
			<Tooltip
				anchorRef={containerRef}
				delay={100}
				position="top"
				visual="private"
			>
				{t('dashboard__qr_table__qr_card__click_to_view_analytics')}
			</Tooltip>
			<div
				ref={containerRef}
				className="flex cursor-pointer flex-col items-center"
			>
				<Link
					className="type-body-small flex items-center gap-1 lowercase text-grey"
					href={`${ROUTES.cabinet.analytics}?id=${qrItem.id}`}
				>
					{t.rich('dashboard__analytics__heatmap_card__scans', {
						count: scans,
						value: (chunks) => (
							<span
								className={cn(
									'type-body-small font-semibold transition-[colors,opacity]',
									isDataStale ? 'animate-pulse text-grey' : 'text-black',
								)}
							>
								{chunks}
							</span>
						),
					})}
				</Link>
			</div>
		</>
	)
}
